import _regeneratorRuntime from "/builds/twentythousand/browser-client/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/twentythousand/browser-client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Queue from "./queue";
/**
 * Create a throttle which runs up to `max` async functions at once
 * @param max - maximum number of async functions to run
 */

export default function makeThrottle(max) {
  // Current iteration cycle
  var current = 0; // Create a FIFO queue

  var queue = new Queue();
  /**
   * Throttle function that throttles the passed func according to `max`
   * @param fn - async function to resolve
   */

  function throttle(fn) {
    return (
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _len,
            args,
            _key,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args2[_key];
                }

                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  /**
                   * Handler for resolving the Promise chain
                   */
                  function handler() {
                    return _handler.apply(this, arguments);
                  } // Return the async handler


                  function _handler() {
                    _handler = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(current < max)) {
                                _context.next = 17;
                                break;
                              }

                              // Increment the available slot size
                              current++;
                              _context.prev = 2;
                              _context.t0 = resolve;
                              _context.next = 6;
                              return fn.apply(void 0, args);

                            case 6:
                              _context.t1 = _context.sent;
                              (0, _context.t0)(_context.t1);
                              _context.next = 13;
                              break;

                            case 10:
                              _context.prev = 10;
                              _context.t2 = _context["catch"](2);
                              reject(_context.t2);

                            case 13:
                              // Since this has now resolved, make the slot available again
                              current--; // If there are items waiting in the queue, resolve the next
                              // Promise

                              if (queue.length > 0) {
                                queue.shift()();
                              }

                              _context.next = 18;
                              break;

                            case 17:
                              // The `max` has been exceeded - push onto the queue to wait
                              queue.push(handler);

                            case 18:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[2, 10]]);
                    }));
                    return _handler.apply(this, arguments);
                  }

                  return handler();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))
    );
  } // Return the throttle function


  return throttle;
}